// extracted by mini-css-extract-plugin
module.exports = {"arrow":"style_arrow__6vQhf","right":"style_right__13mvn","left":"style_left__jAy4e"};